import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

import { IAppState } from '@main-client/src/app/app.state';
import { isAdminOfGroup } from '@main-client/src/app/user/user.helpers';

import { isEmpty } from 'lodash-es';

@Injectable({
  providedIn: 'root',
})
export class MembersDirectoryPermissions {
  currentGroup$ = this.store.select('currentGroup');
  tenant$ = this.store
    .select('tenant')
    .pipe(filter((tenant) => !isEmpty(tenant)));
  user$ = this.store.select('user').pipe(filter((user) => !isEmpty(user)));

  constructor(
    private readonly router: Router,
    private readonly store: Store<IAppState>,
  ) {}

  canActivate() {
    return combineLatest([this.tenant$, this.user$, this.currentGroup$]).pipe(
      take(1),
      map(([tenant, user, groupId]) => {
        if (
          user.isAdmin ||
          isAdminOfGroup(user, { _id: groupId }) ||
          (tenant.enabled_features?.members_directory ?? true)
        ) {
          return true;
        }
        return this.router.createUrlTree(['/']);
      }),
    );
  }
}
